import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { urlServer } from '../global_constants';

export interface ContactPayload {
  fullName: string;
  email: string;
  phone: string;
  structure: string;
  subject: string;
  message: string;
  acceptCommunications: boolean;
  recaptchaToken?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LandingService {

  private readonly contactUrl = `${urlServer}/v1/landing/contact-us`;

  constructor(private http: HttpClient) { }

  async sendContact(data: any, recaptchaToken?: string): Promise<string> {
    const payload: ContactPayload = {
      fullName: data.name,
      email: data.email,
      phone: data.phone,
      structure: data.structure,
      subject: data.object,
      message: data.message,
      acceptCommunications: !!data.conditions,
      recaptchaToken
    };

    try {
      const raw = await this.http.post(this.contactUrl, payload, {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        responseType: 'text'
      }).toPromise();

      const response = JSON.parse(raw);
      return response?.status === 'success' ? 'sent' : 'not_sent';
    } catch (error) {
      console.error('Erreur lors de l\'envoi du contact :', error);
      return 'not_sent';
    }
  }

  noDisposableEmail(): ValidatorFn {
    return (control: AbstractControl) => {
      if (!control.value) return null;

      const emailParts = control.value.split('@');
      if (emailParts.length !== 2) return { invalidEmail: true };

      const domain = emailParts[1].toLowerCase();
      const disposableDomains = [
        'yopmail.com', 'mailinator.com', 'tempmail.com', 'guerrillamail.com', '10minutemail.com',
        'maildrop.cc', 'sharklasers.com', 'throwawaymail.com', 'getnada.com', 'temp-mail.org'
      ];

      return disposableDomains.includes(domain) ? { disposableEmail: true } : null;
    };
  }
}